









import { defineComponent, reactive } from '@vue/composition-api';
import { EntityType } from '@/store/entityModules/types';
import EntityTable from '@/components/common/EntityTable.vue';
import { CheckboxFilter, ICheckboxFilter } from '@/models/filters/Filters';

const Component = defineComponent({
  name: 'PreorderProductsTable',

  components: {
    EntityTable,
  },

  setup() {
    const entityType = EntityType.PREORDER_PRODUCT;

    const filterCheckbox: ICheckboxFilter = new CheckboxFilter({
      label: 'Preorder Only',
    });

    const state = reactive({
      headers: [
        { text: 'Product', value: 'title', sortable: false, searchable: true },
        { text: 'Preorder Enabled', value: 'enablePreorder', sortable: false },
        { text: 'Min Quantity', value: 'minQuantity', sortable: false },
        { text: 'Min Size Quantity', value: 'minSizeQuantity', sortable: false },
        { text: 'Edit', value: 'actions', align: 'right', sortable: false },
      ],
    });

    return {
      entityType,
      state,
      filterCheckbox,
    };
  },
});
export default Component;
